import { authConfig } from "./auth_config";

export interface ApiConfig {
  publicApiUrl: string;
  privateApiUrl: string;
  authApiUrl: string;
}

export function getConfig() {
  // Configure the audience here. By default, it will take whatever is in the config
  // (specified by the `audience` key) unless it's the default value of "YOUR_API_IDENTIFIER" (which
  // is what you get sometimes by using the Auth0 sample download tool from the quickstart page, if you
  // don't have an API).
  // If this resolves to `null`, the API page changes to show some helpful info about what to do
  // with the audience.
  const audience =
    authConfig.audience && authConfig.audience !== "YOUR_API_IDENTIFIER"
      ? authConfig.audience
      : null;

  return {
    domain: authConfig.domain,
    clientId: authConfig.clientId,
    ...(audience ? { audience } : null),
  };
}

export function getApiConfig(): ApiConfig {
  // For backward compatibility, if only REACT_APP_API is set, use it for both
  const defaultApiUrl = process.env.REACT_APP_API || '';

  return {
    publicApiUrl: process.env.REACT_APP_PUBLIC_API || defaultApiUrl,
    privateApiUrl: process.env.REACT_APP_PRIVATE_API || defaultApiUrl,
    authApiUrl: process.env.REACT_APP_AUTH_API || defaultApiUrl,
  };
}
